// PrintArea.tsx
import Barcode from 'react-barcode';
import { fieldStyleMM, PX_PER_MM, type LabelLayoutConfig } from './labelLayout';
import type { LabelRow } from './usePriceListBarcodePrint';

type Props = {
  printRef: React.RefObject<HTMLDivElement>;
  labels: LabelRow[];
  layout: LabelLayoutConfig;

  showName: boolean;
  showCode: boolean;
  showUom: boolean;
  showPrice: boolean;
  showBarcodeText: boolean;

  currency: string;

  getDisplayName: (item: any) => string;
  getDisplayUom: (item: any) => string;
};

export default function PrintArea({
  printRef,
  labels,
  layout,
  showName,
  showCode,
  showUom,
  showPrice,
  showBarcodeText,
  currency,
  getDisplayName,
  getDisplayUom
}: Props) {
  return (
    <div
      ref={printRef}
      style={{ position: 'fixed', left: '-10000px', top: 0, width: 0, height: 0, overflow: 'hidden' }}
    >
      <div className='sheet'>
        <div className='grid'>
          {labels.map(row => {
            const item = row.item;
            const name = getDisplayName(item);
            const uom = getDisplayUom(item);
            const code = String(item?.itemCode ?? '');
            const priceText = `${row.price.toFixed(2)} ${currency}`.trim();
            const b = row.barcode;

            const f = layout.fields;

            return (
              <div className='labelAbs' key={row.key} style={{ width: `${layout.labelWmm}mm`, height: `${layout.labelHmm}mm` }}>
                {!f.name.hidden && showName && <div style={fieldStyleMM(f.name)}>{name}</div>}
                {!f.price.hidden && showPrice && <div style={fieldStyleMM(f.price)}>{priceText}</div>}
                {!f.uom.hidden && showUom && <div style={fieldStyleMM(f.uom)}>{uom}</div>}
                {!f.code.hidden && showCode && <div style={fieldStyleMM(f.code)}>{code}</div>}

                {!f.barcode.hidden && (
                  <div style={{ ...fieldStyleMM(f.barcode), display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Barcode
                      value={b}
                      format={f.barcode.format ?? 'CODE128'}
                      displayValue={f.barcode.showValue ?? false}
                      margin={0}
                      renderer='svg'
                      width={f.barcode.barWidthPx ?? 1.4}
                      height={Math.max(20, Math.floor(f.barcode.hMm * PX_PER_MM))}
                    />
                  </div>
                )}

                {!f.barcodeText.hidden && showBarcodeText && <div style={fieldStyleMM(f.barcodeText)}>{b}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
